module.exports = __webpack_public_path__ + "img/ico1.7399245e.png";